import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import SpeedLineWithDescriptionContainer from '~/src/features/tariffBuilder/containers/SpeedLineWithDescription';

const InternetSpeedBlock = (): JSX.Element => {
    return (
        <>
            <TextWrapper>
                <H3>Безлимитный интернет</H3>
                <Paragraph4 $smaller>Чем быстрее интернет, тем дешевле всё остальное</Paragraph4>
            </TextWrapper>

            <WithSkeleton height={200}>
                <SpeedLineWithDescriptionContainer/>
            </WithSkeleton>
        </>
    );
};

export default InternetSpeedBlock;
